import { DataService } from 'api/DataService'
import { NFeParams } from 'models/NFe'

export class NFeService {
  public static async getNFeDetails(nfs_uuid: string): Promise<NFeParams> {
    // Sem uuid a rota vira /v1/nfses/null e a API responde 400. Não vale a
    // ida ao servidor: o resultado já é conhecido.
    if (!nfs_uuid) return {} as NFeParams

    const response = await DataService({
      type: 'GET',
      url: `/v1/nfses/${nfs_uuid}`
    })

    if (response.status === 200) {
      return response?.data?.record
    }

    return {} as NFeParams
  }
}
